export default __webpack_public_path__ + "static/media/O-009.b7f5b35f.png";